import React from 'react';
import TailwindConfigInjection from './components/layout/TailwindConfigInjection';
import Header from './components/sections/Header';
import Hero from './components/sections/Hero';
import Stats from './components/sections/Stats';
import Programs from './components/sections/Programs';
import VibeGallery from './components/sections/VibeGallery';
import Reviews from './components/sections/Reviews';
import LeadMagnet from './components/sections/LeadMagnet';
import Footer from './components/sections/Footer';
import './styles/globals.css';
import Cursor from './components/sections/Cursor';
import VisualMagnet from './components/sections/VisualMagnet'

const App: React.FC = () => {
  return (
    <>
      <TailwindConfigInjection />
      
      <div className=" text-brand-dark bg-brand-bg antialiased selection:bg-brand-primary selection:text-white md:pb-0">
        <Header />
        
        <main>
          <Cursor />
          <Hero />
          <VisualMagnet />
          <Programs />
          <VibeGallery />
          <Reviews />
          <LeadMagnet />
          <Stats />
        </main>

        <Footer />
      </div>
    </>
  );
};

export default App;